import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import ChatWidget from "@/components/ChatWidget";

export default function WidgetPage() {
  const { token } = useParams();
  const [params] = useSearchParams();
  const sessionId = params.get("sid") || undefined;
  return (
    <div className="h-screen w-screen">
      <ChatWidget token={token} sessionId={sessionId} />
    </div>
  );
}
